// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arrow-button {
  display: flex;
  color: #ffffff;
  background-color: transparent;
  border: 1.5px solid #ffffff;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  font-weight: 300;
  cursor: pointer;
  align-items: center; }

.arrow-button:hover {
  width: 100%;
  border-radius: 32px;
  justify-content: left; }

.arrow-button .absolute {
  display: flex;
  color: #ffffff;
  transition: all 0.3s ease;
  font-weight: 300;
  align-items: center;
  font-size: 14px;
  left: 36%; }

.arrow-button:hover .absolute {
  color: #ffffff;
  left: 16%; }

.arrow-button > .arrow {
  width: 10px;
  height: 10px;
  border-right: 1.5px solid #ffffff;
  border-bottom: 1.5px solid #ffffff;
  position: relative;
  transform: rotate(-45deg);
  margin: 0 10px;
  transition: all 0.3s ease; }

.arrow-button:hover > .arrow {
  transform: rotate(-45deg) translate(4rem, 4rem);
  border-color: #ffffff;
  margin-left: 2rem; }

.arrow-button:hover {
  background-color: #000000;
  color: #fff;
  border: none; }

.arrow-button-black {
  display: flex;
  color: #000000;
  background-color: transparent;
  border: 1.5px solid #000000;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  font-weight: 300;
  cursor: pointer;
  align-items: center; }

.arrow-button-black:hover {
  width: 100%;
  border-radius: 32px;
  justify-content: left; }

.arrow-button-black .absolute {
  display: flex;
  color: #000000;
  transition: all 0.3s ease;
  font-weight: 300;
  align-items: center;
  font-size: 14px;
  left: 36%; }

.arrow-button-black:hover .absolute {
  color: #ffffff;
  left: 16%; }

.arrow-button-black > .arrow {
  width: 10px;
  height: 10px;
  border-right: 1.5px solid #000000;
  border-bottom: 1.5px solid #000000;
  position: relative;
  transform: rotate(-45deg);
  margin: 0 10px;
  transition: all 0.3s ease; }

.arrow-button-black:hover > .arrow {
  transform: rotate(-45deg) translate(4rem, 4rem);
  border-color: #ffffff;
  margin-left: 2rem; }

.arrow-button-black:hover {
  background-color: #1F43DB;
  color: #fff;
  border: none; }

.arrow-button-white {
  display: flex;
  color: #ffffff;
  background-color: transparent;
  border: 1.5px solid #ffffff;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  font-weight: 300;
  cursor: pointer;
  align-items: center; }

.arrow-button-white:hover {
  width: 100%;
  border-radius: 32px;
  justify-content: left; }

.arrow-button-white .absolute {
  display: flex;
  color: #ffffff;
  transition: all 0.3s ease;
  font-weight: 300;
  align-items: center;
  font-size: 14px;
  left: 36%; }

.arrow-button-white:hover .absolute {
  color: #ffffff;
  left: 16%; }

.arrow-button-white > .arrow {
  width: 10px;
  height: 10px;
  border-right: 1.5px solid #ffffff;
  border-bottom: 1.5px solid #ffffff;
  position: relative;
  transform: rotate(-45deg);
  margin: 0 10px;
  transition: all 0.3s ease; }

.arrow-button-white:hover > .arrow {
  transform: rotate(-45deg) translate(4rem, 4rem);
  border-color: #ffffff;
  margin-left: 2rem; }

.arrow-button-white:hover {
  background-color: #1F43DB;
  color: #fff;
  border: none; }

.static-button-primary {
  font-size: 14px;
  font-weight: 300;
  color: #ffffff;
  border-radius: 21px;
  background: #1d1d1b 0% 0% no-repeat padding-box;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  transition: all 200ms ease-in-out; }

.static-button-primary img {
  margin-left: 10px;
  height: 14px; }

.static-button-primary:hover {
  background: #1f43db 0% 0% no-repeat padding-box; }

.static-button-secondary {
  font-size: 14px;
  font-weight: 300;
  color: #ffffff;
  border-radius: 21px;
  background: #1f43db 0% 0% no-repeat padding-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  transition: all 200ms ease-in-out; }

.static-button-secondary img {
  margin-left: 10px;
  height: 14px; }
`, "",{"version":3,"sources":["webpack://./src/components/Button/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS,EAAA;;AAGX;EACE,cAAc;EACd,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB,EAAA;;AAG3B;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,iBAAiB,EAAA;;AAGnB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS,EAAA;;AAGX;EACE,cAAc;EACd,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB,EAAA;;AAG3B;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,iBAAiB,EAAA;;AAGnB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS,EAAA;;AAGX;EACE,cAAc;EACd,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB,EAAA;;AAG3B;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,iBAAiB,EAAA;;AAGnB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iCAAiC,EAAA;;AAGnC;EACE,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,+CAA+C,EAAA;;AAGjD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iCAAiC,EAAA;;AAGnC;EACE,iBAAiB;EACjB,YAAY,EAAA","sourcesContent":[".arrow-button {\n  display: flex;\n  color: #ffffff;\n  background-color: transparent;\n  border: 1.5px solid #ffffff;\n  height: 3rem;\n  width: 3rem;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  cursor: pointer;\n  align-items: center;\n}\n\n.arrow-button:hover {\n  width: 100%;\n  border-radius: 32px;\n  justify-content: left;\n}\n\n.arrow-button .absolute {\n  display: flex;\n  color: #ffffff;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  align-items: center;\n  font-size: 14px;\n  left: 36%;\n}\n\n.arrow-button:hover .absolute {\n  color: #ffffff;\n  left: 16%;\n}\n\n.arrow-button > .arrow {\n  width: 10px;\n  height: 10px;\n  border-right: 1.5px solid #ffffff;\n  border-bottom: 1.5px solid #ffffff;\n  position: relative;\n  transform: rotate(-45deg);\n  margin: 0 10px;\n  transition: all 0.3s ease;\n}\n\n.arrow-button:hover > .arrow {\n  transform: rotate(-45deg) translate(4rem, 4rem);\n  border-color: #ffffff;\n  margin-left: 2rem;\n}\n\n.arrow-button:hover {\n  background-color: #000000;\n  color: #fff;\n  border: none;\n}\n\n.arrow-button-black {\n  display: flex;\n  color: #000000;\n  background-color: transparent;\n  border: 1.5px solid #000000;\n  height: 3rem;\n  width: 3rem;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  cursor: pointer;\n  align-items: center;\n}\n\n.arrow-button-black:hover {\n  width: 100%;\n  border-radius: 32px;\n  justify-content: left;\n}\n\n.arrow-button-black .absolute {\n  display: flex;\n  color: #000000;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  align-items: center;\n  font-size: 14px;\n  left: 36%;\n}\n\n.arrow-button-black:hover .absolute {\n  color: #ffffff;\n  left: 16%;\n}\n\n.arrow-button-black > .arrow {\n  width: 10px;\n  height: 10px;\n  border-right: 1.5px solid #000000;\n  border-bottom: 1.5px solid #000000;\n  position: relative;\n  transform: rotate(-45deg);\n  margin: 0 10px;\n  transition: all 0.3s ease;\n}\n\n.arrow-button-black:hover > .arrow {\n  transform: rotate(-45deg) translate(4rem, 4rem);\n  border-color: #ffffff;\n  margin-left: 2rem;\n}\n\n.arrow-button-black:hover {\n  background-color: #1F43DB;\n  color: #fff;\n  border: none;\n}\n\n.arrow-button-white {\n  display: flex;\n  color: #ffffff;\n  background-color: transparent;\n  border: 1.5px solid #ffffff;\n  height: 3rem;\n  width: 3rem;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  cursor: pointer;\n  align-items: center;\n}\n\n.arrow-button-white:hover {\n  width: 100%;\n  border-radius: 32px;\n  justify-content: left;\n}\n\n.arrow-button-white .absolute {\n  display: flex;\n  color: #ffffff;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  align-items: center;\n  font-size: 14px;\n  left: 36%;\n}\n\n.arrow-button-white:hover .absolute {\n  color: #ffffff;\n  left: 16%;\n}\n\n.arrow-button-white > .arrow {\n  width: 10px;\n  height: 10px;\n  border-right: 1.5px solid #ffffff;\n  border-bottom: 1.5px solid #ffffff;\n  position: relative;\n  transform: rotate(-45deg);\n  margin: 0 10px;\n  transition: all 0.3s ease;\n}\n\n.arrow-button-white:hover > .arrow {\n  transform: rotate(-45deg) translate(4rem, 4rem);\n  border-color: #ffffff;\n  margin-left: 2rem;\n}\n\n.arrow-button-white:hover {\n  background-color: #1F43DB;\n  color: #fff;\n  border: none;\n}\n\n.static-button-primary {\n  font-size: 14px;\n  font-weight: 300;\n  color: #ffffff;\n  border-radius: 21px;\n  background: #1d1d1b 0% 0% no-repeat padding-box;\n  padding: 8px 20px;\n  display: flex;\n  align-items: center;\n  transition: all 200ms ease-in-out;\n}\n\n.static-button-primary img {\n  margin-left: 10px;\n  height: 14px;\n}\n\n.static-button-primary:hover {\n  background: #1f43db 0% 0% no-repeat padding-box;\n}\n\n.static-button-secondary {\n  font-size: 14px;\n  font-weight: 300;\n  color: #ffffff;\n  border-radius: 21px;\n  background: #1f43db 0% 0% no-repeat padding-box;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  transition: all 200ms ease-in-out;\n}\n\n.static-button-secondary img {\n  margin-left: 10px;\n  height: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
